import React, { useState, useEffect } from 'react';
import EventForm from './EventForm';
import SwipeableEventItem from './SwipeableEventItem';

function Dashboard({ user }) {
  const [events, setEvents] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [eventType, setEventType] = useState('');
  const [editingEvent, setEditingEvent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchRecentEvents();
  }, []);

  const fetchRecentEvents = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch('/api/events/recent', {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await response.json();
      if (data.success) {
        setEvents(data.events);
      }
    } catch (error) {
      console.error('Erreur lors du chargement des événements:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleEventAdded = () => {
    setShowForm(false);
    setEventType('');
    setEditingEvent(null);
    fetchRecentEvents();
  };

  const handleDeleteEvent = async (eventId) => {
    if (!window.confirm('Êtes-vous sûr de vouloir supprimer cet événement ?')) {
      return;
    }

    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`/api/events/${eventId}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` }
      });
      
      const data = await response.json();
      if (data.success) {
        fetchRecentEvents();
      } else {
        alert('Erreur lors de la suppression');
      }
    } catch (error) {
      console.error('Erreur:', error);
      alert('Erreur lors de la suppression');
    }
  };

  const handleEditEvent = (event) => {
    setEditingEvent(event);
    setEventType(event.type);
    setShowForm(true);
  };


  const openForm = (type) => {
    setEditingEvent(null);
    setEventType(type);
    setShowForm(true);
  };





  const logout = () => {
    localStorage.removeItem('token');
    window.location.reload();
  };

  if (showForm) {
    return (
      <EventForm
        type={eventType}
        event={editingEvent}
        onSave={handleEventAdded}
        onCancel={() => {
          setShowForm(false);
          setEditingEvent(null);
        }}
      />
    );
  }

  return (
    <div className="p-4 pb-20">
      <div className="flex justify-between items-center mb-6">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">👶 Babytoring</h1>
          <p className="text-gray-600">Bonjour {user.email.split('@')[0]} !</p>
        </div>
        <button
          onClick={logout}
          className="text-gray-500 hover:text-gray-700"
        >
          Déconnexion
        </button>
      </div>

      {/* Boutons d'ajout rapide */}
      <div className="grid grid-cols-2 gap-3 mb-6">
        <button
          onClick={() => openForm('feeding')}
          className="bg-blue-100 hover:bg-blue-200 text-blue-800 p-4 rounded-lg transition-colors"
        >
          <div className="text-2xl mb-2">🍼</div>
          <div className="font-medium">Repas</div>
        </button>

        <button
          onClick={() => openForm('diaper')}
          className="bg-green-100 hover:bg-green-200 text-green-800 p-4 rounded-lg transition-colors"
        >
          <div className="text-2xl mb-2">👶</div>
          <div className="font-medium">Couche</div>
        </button>

        <button
          onClick={() => openForm('temperature')}
          className="bg-red-100 hover:bg-red-200 text-red-800 p-4 rounded-lg transition-colors"
        >
          <div className="text-2xl mb-2">🌡️</div>
          <div className="font-medium">Température</div>
        </button>

        <button
          onClick={() => openForm('bath')}
          className="bg-purple-100 hover:bg-purple-200 text-purple-800 p-4 rounded-lg transition-colors"
        >
          <div className="text-2xl mb-2">💧</div>
          <div className="font-medium">Bain</div>
        </button>
      </div>

      {/* Derniers événements */}
      <div className="bg-white rounded-lg shadow">
        <h2 className="text-lg font-semibold text-gray-900 p-4 border-b">
          Derniers événements
        </h2>
        
        {loading ? (
          <div className="p-4 text-center">
            <div className="inline-block animate-spin rounded-full h-6 w-6 border-b-2 border-primary-600"></div>
          </div>
        ) : events.length === 0 ? (
          <div className="p-4 text-center text-gray-500">
            Aucun événement enregistré
          </div>
        ) : (
          <div className="divide-y divide-gray-200">
            {events.map((event) => (
              <SwipeableEventItem
                key={event.id}
                event={event}
                onEdit={handleEditEvent}
                onDelete={handleDeleteEvent}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default Dashboard;